module.exports = __webpack_public_path__ + "img/2x.6456d3b.jpg";